import PatchController from '../PatchController';

export default class ProfileController extends PatchController {
	public handle() {
		this.redirect(this.routes.profile.indexRoute.href);
	}
}
